export default __webpack_public_path__ + "static/media/DotActive.d870b367.svg";